import { Component, OnInit } from "@angular/core";
import Chart from "chart.js";
import { CommonApiService } from "src/app/services/common-api.service";
import { first } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import $ from "jquery";
declare var $: $;
import * as moment from "moment";
@Component({
  selector: "app-budget",
  templateUrl: "./budget.component.html",
  styleUrls: ["./budget.component.scss"],
})
export class BudgetComponent implements OnInit {
  data: any;
  public datasets: any;
  public dataLabel: any;
  chartData: any = [];
  chartDataLabel: any = [];
  myChart: any;
  chartData24Hours: any = [];
  chartData24HoursLabel: any = [];
  labels: any;

  public clicked: boolean = true;
  public clicked1: boolean = false;
  public clicked2: boolean = false;
  selected_meter_id: any;

  email: any;
  toDate: any;
  fromDate: any;

  loader: boolean = false;
  public uptimePercentage: any;

  today = new Date().toISOString().split("T")[0];
  constructor(
    public commonApi: CommonApiService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loader = true;
    this.selected_meter_id = localStorage.getItem("selected_meter");
    this.getLast24Hours();
  }

  renderGraph(labels, data) {
    if (this.myChart != undefined) {
      this.myChart.destroy();
    }
    let ctx = document.getElementById("myChart");
    this.myChart = new Chart(ctx, {
      type: "line",
      toolTip: labels,
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            borderWidth: 3,
            fill: false,
            borderColor: "#EE3253",
            pointRadius: 0,
          },
        ],
      },

      options: {
        title: {
          display: true,
          text: 'Consumption in Units'
        },
        showToolTips: true,
        // tooltipEvents: ["mousemove", "touchstart", "touchmove"],

        tooltip: data,
        // hover: {
        //   intersect: false,

        // },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                fontColor: "#EE3253",
                fontSize: 14,
                fontStyle: "bold",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                display: true,
              },
            },
          ],
        },
      },
    });
  }

  renderBarGraph(labels, data) {
    if (this.myChart != undefined) {
      this.myChart.destroy();
    }
    let ctx = document.getElementById("myChart");
    this.myChart = new Chart(ctx, {
      type: "bar",
      toolTip: labels,
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            borderWidth: 1,
            borderColor: "#EE3253",
            backgroundColor: "#EE3253",
          },
        ],
      },

      options: {
        title: {
          display: true,
          text: 'Consumption in Units'
        },
        showToolTips: true,
        // tooltipEvents: ["mousemove", "touchstart", "touchmove"],

        tooltip: data,
        // hover: {
        //   intersect: false,

        // },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
          
            {
              barPercentage: 0.2,
              gridLines: {
                display: false,
              },
              ticks: {
                fontColor: "#EE3253",
                fontSize: 14,
                fontStyle: "bold",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                display: true,
              },
            },
          ],
        },
      },
    });
  }

  getStatement() {
    if (Date.parse(this.fromDate) == Date.parse(this.toDate)) {
      this.toastr.error("From data and To date can't be equal");
    } else {
      this.commonApi
        .getEnergyStatement(this.email, this.fromDate, this.toDate)
        .pipe(first())
        .subscribe((res) => {
          this.toastr.success("Statement send to email id");
          $("#form_statement").trigger("reset");
          $("[data-dismiss=modal]").trigger({ type: "click" });
        });
    }
  }

  getLast7days() {
    this.commonApi
      .getBudgetLast7days()
      .pipe(first())
      .subscribe((res: Array<any>) => {
        this.loader = false;
        let labels = [];
        let data = [];
        res.forEach((element) => {
          data.push(element["total_energy"].toFixed(2));
          labels.push(element["day"]);
        });
        // this.renderGraph(labels, data);
        this.renderBarGraph(labels, data);
      });
    var endDate = moment().startOf('day').toISOString(); //the current time
    var startDate = moment().subtract(7, 'day').startOf('day').toISOString()

    this.commonApi.getUpTime(startDate, endDate).pipe(first()).subscribe(res => {
      this.uptimePercentage = res['uptimePercent']
      console.log(this.uptimePercentage, "Week");
    })

  }

  getLast24Hours() {
    this.commonApi
      .getBudgetLast24Hours()
      .pipe(first())
      .subscribe((res: Array<any>) => {
        this.loader = false;
        let labels = [];
        let data = [];
        res.forEach((element) => {
          data.push(element["total_energy"].toFixed(2));
          labels.push(element["hour"].substring(8, 10));
        });
        this.renderGraph(labels, data);
      });
    var endDate = moment().startOf('day').toISOString(); //the current time
    var startDate = moment().subtract(1, 'day').startOf('day').toISOString()

    this.commonApi.getUpTime(startDate, endDate).pipe(first()).subscribe(res => {
      this.uptimePercentage = res['uptimePercent']
    })
  }

  getLast12months() {
    this.commonApi
      .getBudgetMonths()
      .pipe(first())
      .subscribe((res: Array<any>) => {
        this.loader = false;
        let labels = [];
        let data = [];
        res.forEach((element) => {
          data.push(element["energy_consumed"].toFixed(2));
          labels.push(element["month"]);
        });
        // this.renderGraph(labels, data);
        this.renderBarGraph(labels, data);
      });
    var endDate = moment().startOf('day').toISOString(); //the current time
    var startDate = moment().subtract(30, 'day').startOf('day').toISOString()

    this.commonApi.getUpTime(startDate, endDate).pipe(first()).subscribe(res => {
      this.uptimePercentage = res['uptimePercent']
      console.log(this.uptimePercentage, "Month");

    })
  }
}
